import React, { useEffect, useState } from "react";

import "./Report.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel";
import dayjs from "dayjs";
import BtnDownloadTable from "../../Components/Commons/Buttons/BtnDownloadTable";
import { getResidentsReport } from "../../Components/Helpers/API/ReportsApi/ReportsApi";

import { Row, Col } from "react-bootstrap";
import { DatePicker, Select } from "antd";
import { formatDate } from "../../Assets/Helpers/Common";
import {
  capitalizeFirstLetter,
  formatDateWithTime,
  formatPrice,
  getTodayDateISO,
} from "../../Components/Helpers/Utilities/Common";
import { getAllResidents } from "../../Components/Helpers/API/DoctorApi/DoctorApi";
import { DATE_FORMAT, toApiDateRange } from "../../Utils/dateFormat";

const { RangePicker } = DatePicker;

function ResidentReports() {
  const [showLoader, setShowLoader] = useState(false);
  const [totalProfessionalFee, setTotalProfessionalFee] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [residents, setResidents] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
  ]);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const xlsxHeaders = [
    "RESIDENT NAME",
    "PATIENT NAME",
    "PROFESSIONAL FEE",
    "PROFESSIONAL FEE METHOD",
    "COVERAGE NAME"
  ];

  //Function for adding a custom footer in the table
const customFooter = () => (
  <div className="row">
    <div className="col-8" style={{ textAlign: "center" }}>
      Patient Count: {data?.length || 0}
    </div>
    <div className="col-4" style={{ textAlign: "center" }}>
       Total: {totalProfessionalFee ? formatPrice(totalProfessionalFee) : "0.00"}
    </div>
  </div>
);


  //Function for handling the date range in the table
  const onDateChange = (dates) => {
    setDateRange(toApiDateRange(dates));
  };

  //Function for handling the doctor filter in the table
  const handleDoctorChange = (value) => {
    setSelectedDoctor(value);
  };

  //Function for getting pdf header
  const getPdfHeaderTitle = () => {
    if (dateRange[0] && dateRange[1]) {
      var from = formatDate(dateRange[0]);
      var to = formatDate(dateRange[1]);

      return from !== to ? `${from} - ${to}` : from;
    } else {
      return formatDate(getTodayDateISO());
    }
  };

  //Funcion get daily log report API
  async function _get() {
    setShowLoader(true);
    const res = await getResidentsReport({
      date_from: dateRange[0].$isDayjsObject ? getTodayDateISO() : dateRange[0],
      date_to: dateRange[1].$isDayjsObject ? getTodayDateISO() : dateRange[1],
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    });
    if (res.data) {
      var _parsed = res.data.data.map((log) => {
        var pfMethod = (log.professional_fee_method || "").toLowerCase();

        let coverage_name = "";
        if (!["no pf", "gcash", "cash", ""].includes(pfMethod)) {
          if (pfMethod === "hmo") {
            coverage_name = capitalizeFirstLetter(log.hmo_type || "");
          } else {
            coverage_name = capitalizeFirstLetter(log.corporate_type || "");
          }
        }
        return {
          ...log,
          professional_fee: log.professional_fee ? formatPrice(log.professional_fee) : "",
          professional_fee_method: capitalizeFirstLetter(log.professional_fee_method),
          coverage_name
        };
      });
      setData(_parsed);
      var _parsedExcel = res.data.data.map((log) => {
        var _parsedPfMethod = (log.professional_fee_method || "").toLowerCase();

        let _parsed_coverage_name = "";
        if (!["no pf", "gcash", "cash", ""].includes(_parsedPfMethod)) {
          if (_parsedPfMethod === "hmo") {
            _parsed_coverage_name = capitalizeFirstLetter(log.hmo_type || "");
          } else {
            _parsed_coverage_name = capitalizeFirstLetter(log.corporate_type || "");
          }
        }
        return {        
          doctor_name: log.doctor_name,
          formatted_patient_name: log.formatted_patient_name,
          professional_fee: log.professional_fee ? formatPrice(log.professional_fee) : "",
          professional_fee_method: capitalizeFirstLetter(log.professional_fee_method),
          coverage_name: _parsed_coverage_name
        };
      });
      setExcelData(_parsedExcel);
      setTotalProfessionalFee(res.data.total_professional_fee);
    } else if (res.error) {
      setData([]);
      setTotalProfessionalFee("");
    }
    setShowLoader(false);
  }

  // Function for get all residents API
  async function fetchAllResidents() {
    const response = await getAllResidents();
    if (response.data) {
      // setResidents(response.data.data);
      const mappedResidents = response.data.data.map((doctor) => ({
        label: doctor.doctor_name, 
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name
      }));
      setResidents(mappedResidents);
    } else {
      setResidents([]);
    }
  }

  useEffect(() => {
    _get();
    fetchAllResidents();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, selectedDoctor]);

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Resident Reports"} />
      <div className="col p-5 pt-4 manager-container all-container">
        <div className="row pt-3">
          <div className="col font-big title-2 all-patient">
            Resident Reports
          </div>
          <div className="col-2 flex patient-manager">
            <BtnDownloadTable
              label={"Download PDF"}
              size={"sm"}
              data={{
                body: data,
                columns: [
                  { header: "RESIDENT NAME", dataKey: "doctor_name" },
                  { header: "PATIENT NAME,", dataKey: "formatted_patient_name" },
                  { header: "PROFESSIONAL FEE", dataKey: "professional_fee" },
                  { header: "PROFESSIONAL FEE METHOD", dataKey: "professional_fee_method" },
                  { header: "COVERAGE NAME", dataKey: "coverage_name" },
                ],
              }}
              fileName={`${getTodayDateISO()} Resident Report.pdf`}
              pdfHeader={{
                title: `Resident Report (${getPdfHeaderTitle()})`,
                content: `This report is generated on ${formatDateWithTime(
                  new Date()
                )}.`,
              }}
              pdfFooter={{
                content: `Patient Count: ${data?.length || 0}   Total PF Charged = Php ${formatPrice(totalProfessionalFee || "0")}`,
              }}
            />
          </div>
          <div className="col-2 fles patient-manager">
            <BtnExcel
              label={"Download Excel"}
              size={"sm"}
              excelData={excelData}
              xlsxHeaders={xlsxHeaders}
              fileName={"ResidentReport.xlsx"}
            />
          </div>
        </div>
        <Row>
          <Col sm={6}>
            <Row className="row justify-content-start">
              <Col className="pl-0 mb-3">
                <RangePicker
                  onChange={onDateChange}
                  defaultValue={dateRange}
                  format={DATE_FORMAT}
                />
              </Col>
              <Col className="pl-0 mb-3">
                <Select
                  placeholder="Select Doctor"
                  onChange={handleDoctorChange}
                  value={selectedDoctor}
                  style={{width: 300}}
                  allowClear
                  options={residents}
                  optionFilterProp="label"
                  showSearch
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table" id="antd-table-container">
            <AntDTable
              tableHeaders={[
                "RESIDENT NAME",
                "PATIENT NAME",
                "PROFESSIONAL FEE",
                "PROFESSIONAL FEE METHOD",
                "COVERAGE NAME"
              ]}
              headerSelector={[
                "doctor_name",
                "formatted_patient_name",
                "professional_fee",
                "professional_fee_method",
                "coverage_name",
              ]}
              tableData={data}
              loading={showLoader}
              customFooter={customFooter}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResidentReports;
